import apiService from '@/utils/api-client'
import analytics from "@/store/modules/analytics";
import appConfig from '@/utils/appConfig'
import { featureAccess } from '@/utils/accesses'

const getFinalBaseUrl = (explicitUrl) => {
  if (explicitUrl) {
    return explicitUrl;
  }

  if (featureAccess('MULTI_LABELING')) {
    return appConfig.VUE_APP_PROFILES_API_URL;
  }

  return analytics.state.coinData.profilesServiceUrl || null;
};

export default {
  async getProfilesList({ commit }, params = {}) {
    const { baseUrl, configParams = {} } = params;

    try {
      const data = await apiService.get('getProfiles', {
        cancelToken: configParams.cancelToken,
        baseURL: getFinalBaseUrl(baseUrl)
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  async createProfile({ commit }, params) {
    const name = typeof params === 'object' ? params.name : params;
    const baseUrl = params?.baseUrl;

    try {
      const data = await apiService.post(`addProfile`, { name }, {
        baseURL: getFinalBaseUrl(baseUrl)
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  async activateProfile({ commit }, { id, recalc = false, baseUrl }) {
    try {
      const data = await apiService.post(`activateProfile`, { id, recalc }, {
        baseURL: getFinalBaseUrl(baseUrl)
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  async editProfile(ctx, { body, baseUrl }) {
    try {
      const data = await apiService.patch(`updateProfile`, body, {
        baseURL: getFinalBaseUrl(baseUrl)
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  async deleteProfile(ctx, params) {
    const id = typeof params === 'object' ? params.id : params;
    const baseUrl = params?.baseUrl;

    try {
      const data = await apiService.delete(`deleteProfile`, {
        data: { id },
        baseURL: getFinalBaseUrl(baseUrl)
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  },
}
